export enum ImageCalssEnum {
  CardPhoto = 'CardPhoto',
  IDPhoto = 'IDPhoto',
  StudyRoute = 'StudyRoute',
  Certificate = 'Certificate',
  Practice = 'Practice',
  TuitionReceipt = 'TuitionReceipt',
  SquarePhoto = 'SquarePhoto',
}
